<template>
  <div>
    <div class="banner" :style="bannerStyle">
      <div class="banner-head" >{{banner.head}}</div>
      <div class="banner-box" >
        <div class="banner-wrapper">
          <hr class="banner-line">
          <div class="banner-en" >{{banner.headEn}}</div>
          <hr class="banner-line">
        </div>
      </div>
      <div class="banner-subhead">{{banner.subhead}}</div>
    </div>
    <div class="title_box">
      <article v-html="description">
      </article>
    </div>
    <div class="content_box">
      <header>产品试用申请</header>
      <div class="form">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="form.companyName"></el-input>
          </el-form-item>
          <el-form-item label="使用地址" prop="address">
            <el-input v-model="form.address"
                      placeholder="省、地市、区县"
            ></el-input>

          </el-form-item>
          <el-form-item label="需求描述" prop="description">
            <el-input type="textarea" rows="4"
                      placeholder="行业/项目信息/申请内容（指纹/声纹/指静脉）"
                      v-model="form.description" ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit('form')">提交申请</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="steps">
        <el-steps :active="1" align-center  direction="vertical">
          <el-step title="填写信息" description="填写基本的信息"></el-step>
          <el-step title="后台审核" description="详细填写的申请会第一时间处理"></el-step>
          <el-step title="获得账号" description="工作人员会联系您，并给您提供试用账号"></el-step>
        </el-steps>
      </div>
    </div>
  </div>
</template>

<script>
  var validPhone = (rule, value, callback) => {
    // var re = /^\d+$/
    // /^[0-9]+.?[0-9]*/
    // console.log("value: "+value +" >> "+ /^\d+$/.test(value))
    if (!value) {
      callback(new Error('请输入电话号码'));
    } else if (!/^\d+$/.test(value)) {
      callback(new Error('电话号码必须是数字'));
    } else if (value.toString().length != 11) {
      callback(new Error('电话号码必须是11位'));
    } else {
      callback();
    }
  }
  export default {
    name: "Apply",
    mounted() {
      this.$nextTick(() => {
        this.loadData();
      })
    },
    methods:{
      loadData(){
        this.common.post('content/recentOne', {
            'type':'banner',
            'description':'apply',
          },(response)=>{
            this.banner = response.data.content;
            this.bannerStyle = {
              'background-image': 'url('+this.$host+this.banner.image+')'
            };
          }
        )
        this.common.post('content/list', {
            'type': 'cooperation',
          }, (response) => {
            if (response.data.content && response.data.content.length > 0) {
              this.description = response.data.content[0].description;
            }
          }
        )
      },
      successMsg() {
        this.$message({
          message: '恭喜你，申请成功，工作人员会尽快与您联系',
          type: 'success'
        });
      },
      failedMsg() {
        this.$message.error('请检查表单填写');
      },
      onSubmit(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$common.post('apply/save',
              this.form,(response)=>{
                this.form = {};
                this.successMsg();
              })
          } else {
            this.failedMsg();
            return false;
          }
        });
      },
    },
    data() {
      return {
        form: {},
        showForm:true,
        common:this.$common,
        bannerStyle:{},
        banner:{},
        description:'',
        rules: {
          name: [
            { required: true, message: '姓名不能为空', trigger: 'blur' },
            { min: 2, message: '最少2个字符', trigger: 'blur' }
          ],
          email:[
            { required: true, message: '请输入邮箱地址', trigger: 'blur' },
            { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
          ],
          phone:[
            { required: true, message: '电话号码不能为空', trigger: 'blur' },
            { validator: validPhone, trigger: 'blur' },
          ],
          companyName:{ required: true, message: '公司名称不能为空', trigger: 'blur' },
          address:{ required: true, message: '地址不能为空', trigger: 'blur' },
          description:{ required: true, message: '需求描述不能为空', trigger: 'blur' },
        },
      }
    },
  }
</script>

<style scoped>
  .title_box article {
    width: 1200px;
    margin: 0 auto;
    padding: 20px;
    font-size: 14px;
  }
  .content_box{
    width: 1200px;
    margin: auto;
    overflow: hidden;
  }

  .form {
    width: 600px;
    margin: 60px auto;
    float: left;
    overflow: hidden;
  }

  .steps {
    box-sizing: border-box;
    width: 600px;
    padding-left: 110px;
    padding-top: 70px;
    height: 500px;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/Apply.vue